import React from 'react'
import Popover from '@material-ui/core/Popover'
import TextField from '@material-ui/core/TextField'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import './OptionList.scss'
import {IconButton, Checkbox} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import CircularProgress from '@material-ui/core/CircularProgress'
import LoadingIndicator from '../LoadingIcon'

const RootClass = 'option-list'
const OptionList = ({
  anchorEl,
  data = [],
  value = null,
  open,
  loading = false,
  onClose = () => {},
  onChange = (e, value) => {},
}) => {
  const [filtered, setFiltered] = React.useState([])
  const [search, setSearch] = React.useState('')
  const selected = data.find(d => d.id === value?.id)

  const handleClick = (e, data) => {
    onChange(e, data)
  }

  const handleUnselectAll = e => {
    onChange(e, null)
  }

  const handleSearch = e => {
    setSearch(e.target.value)
  }

  React.useEffect(() => {
    const _filtered = data.filter(d => d.name.indexOf(search.toLowerCase()) !== -1)
    setFiltered(_filtered)
  }, [data, search])

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      className="ap-pop-autocomplete__option-popup "
    >
      <div className={`c-res-mod ${RootClass}__search-container`}>
        <TextField
          className={`ap-textfield ${RootClass}__search-field`}
          variant="outlined"
          placeholder="Select Reserved Field"
          value={search}
          onChange={handleSearch}
        />
        <IconButton size="small" className={`${RootClass}__expand-icon`}>
          <ExpandMoreIcon />
        </IconButton>
      </div>
      <div className={`${RootClass}__option-container c-res-mod ap-scrollbar`}>
        {loading && <LoadingIndicator />}
        {!loading && filtered.length === 0 && (
          <div style={{padding: 8}} className="ap-typography ap-typography-sm ap-typography--gray">
            No results
          </div>
        )}
        {filtered.map(d => (
          <OptionRow data={d} selected={value?.id === d.id} onClick={handleClick} />
        ))}
      </div>
    </Popover>
  )
}

const OptionRow = ({data, selected = false, onClick}) => {
  return (
    <div
      className={`${RootClass}__option-row ${selected ? `${RootClass}__option-row--selected` : ''}`}
      onClick={e => onClick(e, data)}
    >
      <div className={`${RootClass}__option-cell ap-typography ap-typography--sm`}>{data.name}</div>
    </div>
  )
}

export default OptionList
